@if (hideTitle()) {
<button mat-icon-button (click)="copy()" [attr.aria-label]="title()" class="rsr-copy-button rsr-copy-button--icon-only">
  <mat-icon fontIcon="content_copy"></mat-icon>
</button>
} @else {
<button mat-flat-button (click)="copy()" class="rsr-copy-button">
  <mat-icon fontIcon="content_copy"></mat-icon>
  {{ title() }}
</button>
}
